import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Team } from "./team";

export class TeamSupplementaryData extends BaseEntity<TeamSupplementaryData> {
    public teamId!: number;
    public accountabilities?: string;

    public team!: Team;
}

export const TeamSupplementaryDataBreezeModel = new BreezeModelBuilder("TeamSupplementaryData", TeamSupplementaryData)
    .hasSource()
    .withPluralName("Team Supplementary Data")
    .isOrganisationEntity()
    .build();
